<template>
  <div class="corporateTraining">
    <app-CorporateTrainingHero></app-CorporateTrainingHero>
    <app-AboutTraining></app-AboutTraining>
    <app-TrainingBenefits></app-TrainingBenefits>
    <app-ContactUs></app-ContactUs>
  </div>
</template>
<script>
import corporateTrainingHero from '../components/classroom/corporateTrainingHero'
import aboutTraining from '../components/classroom/aboutTraining'
import trainingBenefits from '../components/classroom/trainingBenefits'
import contactUs from '../components/classroom/contactUs'
export default {
  name: 'corporateTraining',
  components: {
    appCorporateTrainingHero: corporateTrainingHero,
    appAboutTraining: aboutTraining,
    appTrainingBenefits: trainingBenefits,
    appContactUs: contactUs,
  },
  created() {
    this.Loaded()
    this.TimerAlert("Redirecting:", "Upskill classroom is moved to https://upskillclassroom.com/", 1000);
    setTimeout(() => {
      window.location="https://upskillclassroom.com"
    }, 1000)
  },
}
</script>
